<template>
  <form @submit.prevent="onSubmit">

    <nav class="nav nav-tabs" role="tablist">
      <a href="#options" class="nav-link active" data-toggle="tab">
        تنظیمات
      </a>
      <a href="#translations" class="nav-link" data-toggle="tab">
        ترجمه
      </a>
    </nav>

    <div class="tab-content">
      <div id="options" class="tab-pane pt-4 show active">
        <div class="text-warning text-center ">
          به علت وجود محدودیت بارگذاری در سرور ، فایلهای مرتبط به هر بخش را به صورت جداگانه بارگذاری کنید، به
          این صورت
          که پس
          از انتخاب دو یا نهایت سه فایل اقدام به ثبت تغییرات کنید
        </div>

        <details class="panel mt-3">
          <summary class="h3">هدر وبسایت</summary>

          <div class="row mt-3">
            <div class="col-sm-6">
              <div class="mt-2 form-group">
                <label>ایمیل</label>
                <input type="email" class="form-control" v-model="model.header.email"/>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="mt-2 form-group">
                <label>شماره تماس</label>
                <input type="tel" class="form-control" v-model="model.header.phone"/>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="mt-2 form-group">
                <label>شماره واتس آپ همراه با کد کشور</label>
                <input type="tel" class="form-control" v-model="model.header.whatsapp"/>
                <div class="text-info">
                  Example: 989123456789
                </div>
              </div>
            </div>
          </div>
        </details>
        <details class="panel mt-3">
          <summary class="h3">تنیظمات structured data (Organization)</summary>

          <div class="row mt-3">

            <div class="form-group col-sm-6 mt-2">
              <label>addressLocality</label>
              <textarea class="form-control" placeholder="Example: Tehran, Iran"
                        v-model="model.organization_structured.addressLocality"></textarea>
            </div>
            <div class="form-group col-sm-6 mt-2">
              <label>postalCode</label>
              <textarea class="form-control" placeholder="Example: 1234123412"
                        v-model="model.organization_structured.postalCode"></textarea>
            </div>
            <div class="form-group col-sm-6 mt-2">
              <label>streetAddress</label>
              <textarea class="form-control" placeholder="Example: 38 avenue de l'Opera"
                        v-model="model.organization_structured.streetAddress"></textarea>
            </div>
            <div class="form-group col-sm-6 mt-2">
              <label>email</label>
              <input type="email" class="form-control" placeholder="Example: secretariat@google.org"
                     v-model="model.organization_structured.email"/>
            </div>
            <div class="form-group col-sm-6 mt-2">
              <label>faxNumber</label>
              <textarea class="form-control" placeholder="Example: +092112345678"
                        v-model="model.organization_structured.faxNumber"></textarea>
            </div>
            <div class="form-group col-sm-6 mt-2">
              <label>faxNumber</label>
              <textarea class="form-control" placeholder="Example: +092112345678"
                        v-model="model.organization_structured.faxNumber"></textarea>
            </div>
            <div class="form-group col-sm-6 mt-2">
              <label>name</label>
              <textarea class="form-control" placeholder="Example: Ermateb"
                        v-model="model.organization_structured.name"></textarea>
            </div>
            <div class="form-group col-sm-6 mt-2">
              <label>telephone</label>
              <textarea class="form-control" placeholder="Example: +092123456789"
                        v-model="model.organization_structured.telephone"></textarea>
            </div>

          </div>
        </details>
        <details class="panel mt-3">
          <summary class="h3">فوتر وبسایت</summary>

          <div class="row mt-3">
            <div class="col-sm-6">
              <div class="mt-2 form-group">
                <label>متن درباره ما</label>
                <textarea class="form-control" v-model="model.footer.about_us"></textarea>
              </div>
            </div>
          </div>
        </details>
        <details class="panel mt-3">
          <summary class="h3">آمار وبسایت</summary>

          <div class="mt-5 row">
            <div class="col-sm-6 ">
              <div class="form-group mt-2">
                <label>عمل جراحی موفق</label>
                <input type="number" class="form-control" v-model="model.general.statistics_successful_surgery"/>
              </div>
            </div>
            <div class="col-sm-6 ">
              <div class="form-group mt-2">
                <label>کشور مهمان جهت معالجه</label>
                <input type="number" class="form-control"
                       v-model="model.general.statistics_guest_country_for_treatment"/>
              </div>
            </div>
            <div class="col-sm-6 ">
              <div class="form-group mt-2">
                <label>مشاوره آنلاین در هر ماه</label>
                <input type="number" class="form-control" v-model="model.general.statistics_online_consultation"/>
              </div>
            </div>
            <div class="col-sm-6 ">
              <div class="form-group mt-2">
                <label>زبان بین‌المللی قابل پشتیبانی</label>
                <input type="number" class="form-control" v-model="model.general.statistics_supported_language"/>
              </div>
            </div>
          </div>
        </details>
        <details class="panel mt-3">
          <summary class="h3">نویسنده پیش فرض</summary>

          <div class="mt-5">
            <p>نویسنده پیش فرض برای محتوا و خدمات در صورتی که برای آنها تعیین نشده باشد</p>
            <user-selector :role="['6','7','content-reviewer']"
                           v-model="model.default_author"></user-selector>
          </div>
        </details>
      </div>
      <div id="translations" class="tab-pane pt-4" v-if="translations">

        <details class="panel">
          <summary>ترجمه قالب</summary>

          <div class="mt-3">
            <div class="sticky-top bg-background mb-4 p-2">
              <input type="text" class="form-control"
                     @keydown.enter.prevent
                     v-model="translationFilter.template"
                     @input="$forceUpdate()"
                     placeholder="فیلتر ترجمه ها"/>

            </div>
            <div v-if="translations['v2.template'] && model.translations['v2.template']" class="row mx-0">

              <template v-for="(x,k) in translations['v2.template']">
                <div class="col-sm-4 p-2 d-flex flex-column" :key="k"
                     v-if="!translationFilter.template || k.includes(translationFilter.template)">
                  <label>{{ k }}</label>
                  <textarea class="form-control mt-auto"
                            :placeholder="x"
                            v-model="model.translations['v2.template'][k]"></textarea>
                </div>
              </template>

            </div>
          </div>
        </details>
        <details class="panel mt-3">
          <summary>ترجمه هدر</summary>

          <div class="mt-3">
            <div class="sticky-top bg-background mb-4 p-2">
              <input type="text" class="form-control"
                     @keydown.enter.prevent
                     v-model="translationFilter.header"
                     @input="$forceUpdate()"
                     placeholder="فیلتر ترجمه ها"/>

            </div>
            <div v-if="translations['v2.template.header'] && model.translations['v2.template.header']" class="row mx-0">

              <template v-for="(x,k) in translations['v2.template.header']">
                <div class="col-sm-4 p-2 d-flex flex-column" :key="k"
                     v-if="!translationFilter.header || k.includes(translationFilter.header)">
                  <label>{{ k }}</label>
                  <textarea class="form-control mt-auto"
                            :placeholder="x"
                            v-model="model.translations['v2.template.header'][k]"></textarea>
                </div>
              </template>

            </div>
          </div>
        </details>
        <details class="panel mt-3">
          <summary>ترجمه فوتر</summary>

          <div class="mt-3">
            <div class="sticky-top bg-background mb-4 p-2">
              <input type="text" class="form-control"
                     @keydown.enter.prevent
                     v-model="translationFilter.footer"
                     @input="$forceUpdate()"
                     placeholder="فیلتر ترجمه ها"/>

            </div>
            <div v-if="translations['v2.template.footer'] && model.translations['v2.template.footer']" class="row mx-0">

              <template v-for="(x,k) in translations['v2.template.footer']">
                <div class="col-sm-4 p-2 d-flex flex-column" :key="k"
                     v-if="!translationFilter.footer || k.includes(translationFilter.footer)">
                  <label>{{ k }}</label>
                  <textarea class="form-control mt-auto"
                            :placeholder="x"
                            v-model="model.translations['v2.template.footer'][k]"></textarea>
                </div>
              </template>

            </div>
          </div>
        </details>

      </div>
    </div>


    <div class="bg-background sticky-bottom">
      <ul v-if="errors" class="text-danger mt-2">
        <li v-for="(x,k) in errors" :key="k">{{ x }}</li>
      </ul>

      <div class="mt-3 d-flex align-items-center">
        <button type="submit" class="btn btn-primary">ذخیره تغییرات</button>
        <div class="progress flex-fill ml-3" v-if="uploadProgress > 0">
          <div class="progress-bar progress-bar-striped bg-success" role="progressbar"
               :style="{width: uploadProgress + '%'}" aria-valuenow="25" aria-valuemin="0"
               aria-valuemax="100"></div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import {message, xhr} from "@/tools/functions";
import {EditorMixin} from "@/tools/helpers/contents";
import UserSelector from "@/components/UserSelector.vue";

const initialModel = {
  general: {},
  header: {},
  footer: {},
  organization_structured: {},
  translations: {}
};
export default {
  name: "GeneralTemplateSettings",
  components: {UserSelector},
  mixins: [EditorMixin],
  props: {
    language_code: {default: undefined}
  },
  data: () => ({
    removed_files: [],
    model: {...initialModel},
    working: false,
    errors: undefined,
    uploadProgress: -1,
    files: {},


    translationFilter: {template: '', header: '', footer: ''},
    translations: undefined,
  }),
  methods: {
    onSubmit() {
      if (!this.language_code || this.working)
        return;
      this.working = true;
      this.errors = undefined;

      const fd = new FormData();
      const model = {...this.model};
      this.$el.querySelectorAll('.tiny-editor[data-key]').forEach(x => {
        model[x.getAttribute('data-key')] = this.tinyMCEGetContent(x.id)
      })

      fd.append('data', new Blob([JSON.stringify(model)], {type: 'application/json'}), 'data.json');
      fd.append('extra', this.url);
      fd.append('validate-duplicate-extra', '1');
      if (this.removed_files && this.removed_files.length > 0)
        fd.append('removed_files', JSON.stringify(this.removed_files));

      this.$el.querySelectorAll('input[type=file][data-key]').forEach(x => {
        if (x.files.length > 0) {
          fd.append(x.getAttribute('data-key'), x.files[0]);
        }
      })

      xhr(`api/metas/public-pages/template/general-settings-${this.language_code}`, 'post', fd, pc => this.uploadProgress = pc)
          .then(() => {
            message('اطلاعات با موفقیت بارگذاری شد');
            this.removed_files = [];
            this.$refs.linkToServiceImageInput.value = '';
            this.$refs.backgroundImageInput.value = '';
            this.retrieveSettings()
          })
          .catch(x => {
            const errors = x.responseJSON;
            if (errors && errors['duplicated-extra'])
              this.errors = {url: 'آدرس وارد شده تکراری است'}
          })
          .finally(() => {
            this.working = false;
            this.uploadProgress = -1;
          })
    },
    retrieveSettings() {
      if (!this.language_code)
        return;
      this.working = true;
      this.removed_files = [];
      xhr(`api/metas/public-pages/template/general-settings-${this.language_code}`, 'get', {
        withFiles: 1
      })
          .then(x => {
            const data = JSON.parse(x.data.value) || {};
            this.model = {...initialModel, ...data};
            this.$el.querySelectorAll('.tiny-editor[data-key]').forEach(x => {
              this.tinyMCESetContent(x.id, this.model[x.getAttribute('data-key')] || '')
            })
            this.files = x.data.files || {};
            this.existenceUrl = this.url = x.data.extra;

            for (const key of Object.keys(this.translations)) {
              if (!this.model.translations[key])
                this.model.translations[key] = this.translations[key] || {};
            }
          })
          .catch(() => {
          })
          .finally(() => this.working = false)

    },
    addVideoScript(key) {
      if (Array.isArray(this.model[key]))
        this.model[key].push('')
      else
        this.model[key] = [''];
      this.$forceUpdate();
    },
    onAddMostVisitedService() {
      if (this.tempService) {
        const htmlContainer = document.createElement('div');
        htmlContainer.innerHTML = this.tempService.description;
        const value = {
          medicine_service_id: this.tempService.medicine_service_id,
          name: this.tempService.name,
          url: this.tempService.url,
          image: this.tempService.image,
          description: htmlContainer.innerText
        }
        if (Array.isArray(this.model.mostVisitedService))
          this.model.mostVisitedService.push(value)
        else
          this.model.mostVisitedService = [value];

        this.$forceUpdate();
      }
    },
    onRemoveService(item, key) {
      if (this.files[`image-for-service--${item.medicine_service_id}`]) {
        this.removed_files.push(`image-for-service--${item.medicine_service_id}`);
      }
      if (this.files[`title-icon-for-service--${item.medicine_service_id}`]) {
        this.removed_files.push(`title-icon-for-service--${item.medicine_service_id}`);
      }
      this.model.mostVisitedService.splice(key, 1);
      this.$forceUpdate();
    },
    onAddMember() {
      if (this.tempMember.id && this.model.members) {
        const updateIndex = this.model.members.findIndex(x => x.id === this.tempMember.id);
        if (updateIndex >= 0) {
          this.model.members.splice(updateIndex, 1, {...this.tempMember});
          this.tempMember = {};
          return;
        }
      }

      const value = {
        ...this.tempMember,
        id: crypto ? crypto.randomUUID() || Date.now() : Date.now()
      };
      if (Array.isArray(this.model.members)) {
        //check for prevent duplicate id
        while (this.model.members.findIndex(x => x.id === value.id) >= 0) {
          value.id = crypto ? crypto.randomUUID() || Date.now() : Date.now();
        }
        this.model.members.push(value)
      } else
        this.model.members = [value];

      this.tempMember = {};
    },
    onDeleteMember(item) {
      if (confirm('آیا از حذف اطمینان دارید؟')) {
        const index = this.model.members.findIndex(x => x.id === item.id);
        if (index >= 0) {
          if (this.files[`member-${item.id}`]) {
            this.removed_files.push(`member-${item.id}`);
          }
          this.model.members.splice(index, 1);
        }
      }
    },
    retrieveTranslations() {
      xhr('api/translator', 'get', {
        paths: ['v2.template', 'v2.template.footer', 'v2.template.header']
      })
          .then(x => {
            this.translations = x.data
            if (!this.model.translations)
              this.model.translations = x.data;
            else {
              for (const key of Object.keys(x.data)) {
                if (!this.model.translations[key])
                  this.model.translations[key] = x.data[key];
              }
            }
          })
    },
  },
  watch: {
    language_code(n, o) {
      if (n !== o) {
        this.model = {...initialModel};
        this.$el.querySelectorAll('.tiny-editor[data-key]').forEach(x => {
          this.tinyMCESetContent(x.id, '')
        });
        this.retrieveSettings();
      }
    }
  },
  mounted() {
    this.retrieveSettings();
    this.retrieveTranslations();
    this.$el.querySelectorAll('.tiny-editor').forEach(x => this.tinyMCEInit(x.id))
  }
}
</script>

<style scoped>

</style>